import axios from "axios";
import Cookies from "js-cookie";

export const addAdvisor = ({ adminEmail, requestBody }) =>
  axios.post(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/addUserManager`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${adminEmail}`)}`,
      },
    }
  );

export const deleteAdvisor = ({ adminEmail, advisorEmail }) =>
  axios.post(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/removeUserManager`,
    {
      email: advisorEmail,
    },
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${adminEmail}`)}`,
      },
    }
  );

export const openAdvisorView = ({ adminEmail, advisorEmail, organization }) =>
  axios(
    `${
      process.env.REACT_APP_HOME_API_DOMAIN
    }/loadUserManager?email=${encodeURIComponent(advisorEmail)}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${adminEmail}`)}`,
      },
    }
  ).then(response => {
    Cookies.set(
      `jwt__${decodeURIComponent(advisorEmail)}`,
      response?.data?.jwt,
      {
        expires: 0.5, // half a day (12 hours)
        secure: true,
      }
    );
  });

export const updateAdvisor = ({ adminEmail, requestBody }) =>
  axios.post(
    `${process.env.REACT_APP_HOME_API_DOMAIN}/updateUserManager`,
    requestBody,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get(`jwt__${adminEmail}`)}`,
      },
    }
  );
